@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.codeWrapper {
  font-weight:  hevo-toolkit-variables.$font-weight-bold;
  margin: 0  hevo-toolkit-variables.$spacer * 0.125;
  &.ip {
    color:  hevo-toolkit-variables.$error-secondary;
    background-color:  hevo-toolkit-variables.$error-faded;
  }
}
